/**
 * Engaging, format/operation-aware status sentences shown while the agent works
 * on an artifact, so the user stays informed it's actively building (used by the
 * chat thinking indicator and the artifact panel). Every sequence ends on
 * "Just a moment…", after which the finished artifact appears.
 */
export function artifactStatusSeq(
  t: (k: string) => string,
  fmt?: string,
  op?: string,
): string[] {
  const k = (s: string) => t(`chat.artifacts.status.${s}`);
  const tail = [k('almostReady'), k('justAmoment')];
  switch (fmt) {
    case 'pptx':
      return [op === 'edit' ? k('updatingDeck') : k('designingDeck'), k('addingVisuals'), k('applyingBrand'), ...tail];
    case 'docx':
      return [op === 'edit' ? k('updatingDoc') : k('writingDoc'), k('formatting'), k('applyingBrand'), ...tail];
    case 'markdown':
      return [k('writingMd'), k('formatting'), k('justAmoment')];
    case 'html':
      return [k('buildingHtml'), k('addingVisuals'), ...tail];
    case 'gforms':
      return [k('preparingForm'), k('addingVisuals'), k('almostReady'), k('justAmoment')];
    default:
      // Format not known yet (the agent is still reading the brand / planning) —
      // keep it engaging until create/edit reveals the format.
      return [k('preparing'), k('reviewingBrand'), k('planning'), k('puttingTogether'), k('justAmoment')];
  }
}

export default artifactStatusSeq;
